module.exports = __webpack_public_path__ + "img/arrow-down-square-triangle.465c49e1.svg";